<!--
* 组件名 : 书籍
* 开发者 : JY
*
* 参数:
*   books     { Object } -  书籍数据
*
* 事件: null
*   
*
-->

<template>
  <div class="v-books">
    <div :class="['book-content d-flex flex-wrap', className, showDescOnly ? 'showDescOnly' : '']">
      <h2 class="books-title" v-if="(booksTitle && !showDescOnly)">{{ booksTitle }}</h2>
      <div class="book-item" v-for="(item, i) in books.data" :key="i" ref="bookItem">
        <div class="item-box d-flex">
          <div class="book-img" v-if="!showDescOnly">
            <a :href="item.link" target="_blank">
              <img :src="item.poster" :alt="item.title" />
            </a>
          </div>
          <template v-if="showDescOnly">
            <div class="info-text" v-html="item.description"></div>
          </template>
          <template v-else>
            <div class="book-info">
              <div class="info-content">
                <div class="info-text" v-html="item.description"></div>
              </div>

              <v-btn class="page-arrow" @btnClick="on_expand_or_packup(i)">
                <span>{{ $TL.expandAll }}</span>
                <v-icon>expand_more</v-icon>
              </v-btn>
            </div>
          </template>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getStyle, timeout } from "@/utils/util";
export default {
  name: "v-books",
  props: {
    books: {
      type: Object,
      required: true,
    },
    showDescOnly: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  data() {
    return {
      className: "",
      booksTitle: "",
      isExpandAll: false,
    };
  },

  created() {
    this.on_books_count_judge();
  },
  mounted() {
    this.book_layout();
    timeout(100).then(() => this.get_text_height());
  },
  methods: {
    /**
     *  判断有几本书
     */
    on_books_count_judge() {
      if (this.books.data.length > 1) {
        this.className = "multiple";
      } else {
        this.booksTitle = this.books.data[0].title;
      }
    },

    /**
     *  书籍简介的展开收起
     */
    on_expand_or_packup(index) {
      let $textBox = $(this.$refs.bookItem[index]).find(".info-text");
      this.isExpandAll = !this.isExpandAll;

      let text_change = (text) => {
        $(this.$refs.bookItem[index])
          .addClass(this.isExpandAll && "expand")
          .find(".v-btn span")
          .text(text);
      };

      text_change(this.isExpandAll ? this.$TL.packUp : this.$TL.expandAll);
      this.desc_fade_animate($textBox);
    },

    /**
     *  书籍描述展开收起fade 动画
     */
    desc_fade_animate($textBox) {
      if (this.isExpandAll) {
        $textBox.velocity({
          height: $textBox.get(0).scrollHeight,
        });
      } else {
        $textBox.velocity(
          {
            height: parseInt($textBox.attr("h")),
          },
          {
            complete: () => {
              $textBox.parents(".book-item").removeClass("expand");
            },
          }
        );
      }
    },

    /**
     *  设置书籍初始描述高度
     */
    get_text_height() {
      let $item = $(".info-text>p").length
        ? $(".info-text>p")
        : $(".info-text");
      let lineH = parseInt(getStyle($item.get(0)).lineHeight);
      let fontSize = parseInt(getStyle($item.get(0)).fontSize);

      $(this.$refs.bookItem).map((i, item) => {
        let $infoText = $(item).find(".info-text");
        let $bookImg = $(item).find(".book-img>a");
        let initH = $bookImg.outerHeight();

        //  js 计算限制行数
        if ($infoText.outerHeight() - 16 > initH) {
          let maxLine = Math.floor(initH / lineH - 1);
          let maxH = lineH * maxLine;
          $infoText
            .attr("style", `-webkit-line-clamp: ${maxLine};`)
            .addClass("limit");
          //  隐藏后面段落，再对比一次高度
          if ($infoText.outerHeight() < initH) {
            maxH = $infoText.outerHeight();
          }

          $infoText.attr("H", maxH).css({ height: `${maxH}px` });
        } else {
          $(item)
            .find(".v-btn")
            .remove();
        }
      });
    },

    /**
     *  判断是否显示展开收起按钮
     */
    is_btn_show() {
      $(this.$refs.bookItem).map((i, item) => {
        let $infoContent = $(item).find(".info-content");
        let $infoText = $infoContent.children(".info-text");

        if ($infoText.get(0).scrollHeight - 5 < $infoContent.outerHeight()) {
          $(item)
            .find(".v-btn")
            .remove();
        }
      });
    },

    /**
     * 判断外文书籍竖向排列
     */

    book_layout() {
      this.$P.isLatin && (this.className = "");
    },
  },
};
</script>

<style lang="scss">
.book-content {
  width: 850px;
  margin: 0 auto;
  padding: 184px 0 160px 0;

  &.multiple {
    .book-item {
      width: 100%;
    }
  }

  &.showDescOnly .book-item {
    width: 700px;
    margin: 0 auto;

    .item-box .info-text p {
      font-size: 20px;
      text-indent: 40px;
    }
  }

  .book-item {
    &.expand {
      .page-arrow {
        i {
          transform: rotate(180deg);
        }
      }

      .info-text.limit {
        p {
          display: block !important;
        }
      }
    }

    &:not(.expand) {
      .info-text {
        display: block;
        display: -webkit-box;
        overflow: hidden;
        text-overflow: ellipsis;
        -webkit-box-orient: vertical;
      }
    }

    .info-text {
      overflow: hidden;

      &.limit {
        p:nth-of-type(n + 2) {
          display: none;
        }
      }
    }

    .book-img {
      width: 198px;
    }

    .book-info {
      width: calc(100% - 198px);
      max-width: 654px;
      padding-left: 40px;
    }

    .info-content {
      width: 100%;
    }

    .item-box {
      width: 100%;

      &:hover {
        a {
          transform: translateY(-6px);

          img {
            box-shadow: 4px 14px 22px rgb(0 0 0 / 30%);
          }
        }
      }

      .book-img {
        flex-shrink: 0;

        a {
          display: block;
          width: 100%;
          padding-top: 140.55%;
          position: relative;
          background-color: $color-placeholder;
        }

        a,
        img {
          transition: all 0.35s ease;
        }
      }

      img {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
      }

      .book-info {
        p {
          width: 100%;
          margin-bottom: 16px;

          &:last-of-type(1) {
            margin-bottom: 0;
          }

          @-moz-document url-prefix() {
            overflow: hidden;
          }

          @media not all and (min-resolution: 0.001dpcm) {
            @supports (-webkit-appearance: none) {
              overflow: hidden;
            }
          }
        }
      }

      .info-text,
      .info-text p {
        font-size: 18px;
        font-family: "Microsoft YaHei";
      }
    }

    .page-arrow {
      margin: 8px auto;

      span,
      i {
        color: $color-second-title;
      }
    }
  }

  .books-title {
    width: 100%;
    font-size: 32px;
    text-align: center;
    margin-bottom: 112px;
  }

  @media (min-width: $lx-min) {
    width: 1340px;

    &.multiple {
      .book-item {
        width: 50%;

        &:nth-of-type(1) {
          padding-right: 2.85%;
        }

        &:nth-of-type(2) {
          padding-left: 2.85%;
        }

        .book-img {
          width: 35.21%;
        }

        .book-info {
          width: 64.79%;
          padding-left: 6.2%;
        }
      }
    }

    &:not(.multiple) {
      width: 960px;

      .book-item {
        .book-img {
          width: 250px;
        }

        .book-info {
          width: calc(100% - 250px);
          max-width: 710px;
        }
      }
    }

    .book-item {
      &:not(.expand) {
        .info-text {
          // @include limit-line(12, 1.5, null);
        }
      }
    }

    .books-title {
      font-size: 40px;
    }
  }

  @media (min-width: $lx-max) {
    width: 1510px;
  }

  @media (max-width: $lx-min - 1px) {
    &.multiple {
      .book-item:nth-of-type(1) {
        margin-bottom: 72px;
      }
    }
  }
}

body[data-lang="zh-TW"],
body[data-lang="zh-CN"] {
  .book-item {

    .info-text,
    .info-text p {
      text-indent: 2em;
    }
  }
}

//  书籍描述外文字体
body.latin {
  .v-books {
    .book-content.showDescOnly .book-item {
      width: 800px;
    }

    .book-item {
      &:nth-of-type(2) {
        margin-top: 72px;
      }

      .item-box {

        .info-text,
        .info-text p {
          font-family: Georgia;
        }
      }
    }

    .books-title {
      font-size: 30px;
    }

    @media (min-width: $lx-max) {
      .books-title {
        font-size: 32px;
      }
    }
  }
}
</style>
